import { useCallback, useEffect, useState } from 'react';

/**
 * A hook to manage a reset counter for a sidebar, which can be used to trigger
 * resets in the sidebar context (using key prop). The counter resets when the
 * sidebar is closed.
 * @param isOpen - A boolean indicating whether the sidebar is open
 */
export const useSidebarResetCounter = (isOpen: boolean) => {
  const [resetKey, setResetKey] = useState(0);
  const [hasReset, setHasReset] = useState(false);

  const handleReset = useCallback(() => {
    setResetKey(Date.now());
    setHasReset(true);
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setResetKey(Date.now());
      setHasReset(false);
    }
  }, [isOpen]);

  return { resetKey, handleReset, hasReset };
};
